import React, { memo } from 'react'
import { PDFDownloadLink } from '@react-pdf/renderer';
import HistoryPdf from './HistoryPdf';
const GenerateHistoryInvoice = ({item,merchant }) => {
    const fileName = `lead-Invoice`;
    return (
        <div className='download-link'>
            <PDFDownloadLink
                document={<HistoryPdf pdfData={item.info} transaction_id={item.transaction_id} createdAt={item.createdAt} merchant={merchant} />}
                fileName={fileName}
            >
                <center><button className='btn btn-success text-white my-3'  >
                    Download Invoice
                </button></center>
            </PDFDownloadLink>
        </div>
    )
}

export default memo(GenerateHistoryInvoice)